define('BackendBase',[
	'jquery',
	'lodash',
	'env',
	'v3/Common/Services/frontend/Frontend.Service',
	'v3/Common/Services/jwtTokenService',
	'v3/Common/Services/jwtService',
	'safe-mode',
	'v3/Common/Helpers/SignedCookies/requestSignedCookies'
], function ($, _, env, frontend, jwtTokenService, jwtService, safeModeService, signedCookies) {
	var BackendBase = function () { };

	var classId = env.userInfo.classId;
	var countryId = env.userInfo.countryId;

	var apiPrefix = '/api/' + classId + '/';

	function commonReturn (data) {
		// jQuery promises return by default an array as first argument (e.g. [data, status, XMLRequest])
		// We only want the data as first argument, therefor we return the data
		return data;
	}

	function defaultCallBack (jqXHR, textStatus, errorThrown) {
		safeModeService.safeMode.check();

		if (this.showError !== false) {
			frontend.notification.ajax.error();
		}

		if (textStatus === 'parsererror') {
			console.error('BackendBase report\n', errorThrown, '\nParsed text:', jqXHR.responseText.substring(0, 50) + '...');
		}

		return $.Deferred().reject(jqXHR, textStatus, errorThrown);
	}

	function commonExternalApiAjaxCallBack (jqXHR, textStatus, errorThrown) {
		switch (jqXHR.status) {
		case 401:
			var returnUrl = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
			window.location.href = '/V3/' + classId + '/Account/LogOn?returnUrl=' + returnUrl;
			break;
		default:
			return defaultCallBack.call(this, jqXHR, textStatus, errorThrown);
		}
	}

	function commonFailAjaxCallback (jqXHR, textStatus, errorThrown) {
		switch (jqXHR.status) {
		case 401:
			// If the Require-Login header is set
			// then redirect to login page with a reload
			// else, continue to default case.
			if (jqXHR.getResponseHeader('Require-Login')) {
				window.location.reload();
				break;
			}
		// break omitted
		default:
			return defaultCallBack.call(this, jqXHR, textStatus, errorThrown);
		}
	}

	function createAJAX (url, data, options, optionsFunction) {
		var ajaxOptions = optionsFunction(options, data);
		return $.ajax(_.extend(ajaxOptions, {
			url: url,
			type: ajaxOptions.type || 'GET',
			contentType: ajaxOptions.contentType || 'application/json; charset=utf-8',
			dataType: ajaxOptions.dataType || null,
			data: ajaxOptions.data || null,
			headers: ajaxOptions.headers || null
		}));
	}

	function getOptions (options, data) {
		var result = commonOptions(options, null, 'GET');
		result.data = data;
		return result;
	}

	function getHtmlOptions (options, data) {
		var result = getOptions(options, data);
		result.contentType = 'text/plain';
		return result;
	}

	function getJsonOptions (options, data) {
		var result = getOptions(options, data);
		result.dataType = 'json';
		return result;
	}

	function postOptions (options, data) {
		var result = commonOptions(options, data, 'POST');
		return result;
	}

	function postJsonOptions (options, data) {
		var result = postOptions(options, data);
		result.dataType = 'json';
		return result;
	}

	function putOptions (options, data) {
		var result = commonOptions(options, data, 'PUT');
		return result;
	}

	function patchOptions (options, data) {
		var result = commonOptions(options, data, 'PATCH');
		return result;
	}

	function deleteOptions (options, data) {
		var result = commonOptions(options, data, 'DELETE');
		return result;
	}

	function commonOptions (options, data, method) {
		var result = _.isPlainObject(options) ? _.extend({}, options) : {};
		result.data = JSON.stringify(data);
		result.type = method;
		return result;
	}

	function getAuthorizationHeader (token) {
		return {
			'Authorization': 'Bearer ' + token
		};
	}

	function checkAccessToken () {
		var promise = $.Deferred();

		jwtService.getAccessToken()
			.then(function (accessToken) {
				if (jwtTokenService.isTokenExpired(accessToken)) {
					jwtService.refresh().then(function (t) {
						signedCookies.requestSignedCookies(t, env.environment === 'production' ? 'prod' : 'master');

						promise.resolve(t);
					}, function () {
						promise.reject({ status: 401 });
					});
				} else {
					setTimeout(function () {
						promise.resolve(accessToken);
					}, 10);
				}
			});

		return promise;
	}

	function checkImpersonateToken (accessToken) {
		var impersonateToken = jwtService.getImpersonateToken();

		if (jwtTokenService.isImpersonating(accessToken)) {
			if (!jwtTokenService.isImpersonatingTokenValid(impersonateToken)) {
				return jwtTokenService.renewImpersonateToken(accessToken)
					.then(function (newImpersonateToken) {
						jwtService.setImpersonateToken(newImpersonateToken.token);

						return newImpersonateToken.token.access_token;
					});
			}

			return $.Deferred().resolve(impersonateToken).promise();
		}

		jwtService.resetImpersonateToken();
		return $.Deferred().resolve(accessToken).promise();
	}

	function jsonApiCall (url, data, options, optionFunction) {
		return $.when(checkAccessToken())
			.then(checkImpersonateToken)
			.then(function (token) {
				var ajaxOptions = _.isPlainObject(options) ? _.extend({}, options) : {};
				ajaxOptions.headers = getAuthorizationHeader(token);

				return createAJAX(url, data, ajaxOptions, optionFunction);
			})
			.then(commonReturn, commonExternalApiAjaxCallBack);
	}

	function getApiUrl (url) {
		return apiPrefix + url;
	}

	$.extend(BackendBase.prototype, {
		_getApiUrl: function (url) {
			return getApiUrl(url);
		},

		_getHtml: function (url, options) {
			return createAJAX(url, null, options, getHtmlOptions)
				.then(commonReturn);
		},

		_getJsonApi: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, getJsonOptions)
				.then(commonReturn)
				.fail(commonFailAjaxCallback);
		},

		_post: function (url, data, options) {
			return createAJAX(url, data, options, postOptions)
				.fail(commonFailAjaxCallback);
		},

		_postApi: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, postOptions)
				.fail(commonFailAjaxCallback);
		},

		_postJson: function (url, data, options) {
			return createAJAX(url, data, options, postJsonOptions)
				.then(commonReturn)
				.fail(commonFailAjaxCallback);
		},

		_postJsonApi: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, postJsonOptions)
				.then(commonReturn)
				.fail(commonFailAjaxCallback);
		},

		_put: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, putOptions)
				.fail(commonFailAjaxCallback);
		},

		_patch: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, patchOptions)
				.fail(commonFailAjaxCallback);
		},

		_delete: function (url, data, options) {
			var apiUrl = getApiUrl(url);
			return createAJAX(apiUrl, data, options, deleteOptions)
				.fail(commonFailAjaxCallback);
		},

		_getJsonApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, getOptions);
		},

		_deleteApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, deleteOptions);
		},

		_postJsonApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, postJsonOptions);
		},

		_postApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, postOptions);
		},

		_putApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, putOptions);
		},

		_patchApiWithJwtAuthorization: function (url, data, options) {
			return jsonApiCall(url, data, options, patchOptions);
		},

		getToken: function (callback) {
			return $.when(checkAccessToken())
				// .then(checkImpersonateToken)
				.done(function (token) {
					callback(token);
				})
				.fail(commonExternalApiAjaxCallBack);
		},

		classId: classId,
		countryId: countryId
	});

	return BackendBase;
});
